export default __webpack_public_path__ + "static/media/0.f38aae2a.png";